import { createReducer, on } from '@ngrx/store';
import { setAdvertisementListPageNumber, setAdvertisementListItemsPerPage, setAdvertiserListPageNumber, setAdvertiserListItemsPerPage } from '../actions/advertisement-management.action';

export interface AdvertisementState {
    pageNumberAdvertisementList: number;
    itemsPerPageAdvertisementList: number;
    pageNumberAdvertiserList: number;
    itemsPerPageAdvertiserList: number;
}

export const initialState: AdvertisementState = {
    pageNumberAdvertisementList: 1,
    itemsPerPageAdvertisementList: 10,
    pageNumberAdvertiserList: 1,
    itemsPerPageAdvertiserList: 10,

};

export const advertisementManagementReducer = createReducer(
    initialState,
    on(setAdvertisementListPageNumber, (state, { pageNumberAdvertisementList }) => ({ ...state, pageNumberAdvertisementList })),
    on(setAdvertisementListItemsPerPage, (state, { itemsPerPageAdvertisementList }) => ({ ...state, itemsPerPageAdvertisementList })),
    on(setAdvertiserListPageNumber, (state, { pageNumberAdvertiserList }) => ({ ...state, pageNumberAdvertiserList })),
    on(setAdvertiserListItemsPerPage, (state, { itemsPerPageAdvertiserList }) => ({ ...state, itemsPerPageAdvertiserList })),
);